export const TAG_GROUPS = {
  FROM_CSV: 'TAG_FROM_CSV',
  USER_STATUS: 'USER_STATUS',
  USER_FREQUENCY: 'USER_FREQUENCY',
  MEMBERSHIP: 'MEMBERSHIP',
  MAX_HISTORIC_LEVEL: 'MAX_HISTORIC_LEVEL',
  LEVEL_TRANSITION: 'LEVEL_TRANSITION',
  COOLING_DOWN: 'COOLING_DOWN',
  LAST_REVIEW: 'LAST_REVIEW',
  FORM_STATE: 'FORM_STATE',
  RITMO: 'RITMO',
  WEEKDAY: 'WEEKDAY',
  GREEN_TEST: 'GREEN_TEST',
  GENDER: 'GENDER',
  CONSUMPTION_MODE: 'CONSUMPTION_MODE',
  AGE_GROUP: 'AGE_GROUP',
  TIME_SLOT: 'TIME_SLOT',
  STORES: 'STORES',
} as const

// Grupos que pertenecen a "Tags por uso"
export const USAGE_TAG_GROUPS = [
  TAG_GROUPS.USER_STATUS,
  TAG_GROUPS.USER_FREQUENCY,
  TAG_GROUPS.MEMBERSHIP,
  TAG_GROUPS.MAX_HISTORIC_LEVEL,
  TAG_GROUPS.LEVEL_TRANSITION,
  TAG_GROUPS.COOLING_DOWN,
  TAG_GROUPS.LAST_REVIEW,
  TAG_GROUPS.FORM_STATE,
  TAG_GROUPS.RITMO,
  TAG_GROUPS.WEEKDAY,
  TAG_GROUPS.GREEN_TEST,
  TAG_GROUPS.GENDER,
  TAG_GROUPS.CONSUMPTION_MODE,
  TAG_GROUPS.AGE_GROUP,
  TAG_GROUPS.TIME_SLOT,
] as const
